import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';

import CustomLink from './CustomLink';
import Detail from './Detail';
import Term from './Term';

const height = '24px';
const ICON_SX = { fontSize: 15, color: 'primary.main' } as const;

const ContactDetails: React.FC = () => {
  return (
    <Box
      component='dl'
      aria-label='contact-information'
      sx={{
        display: 'grid',
        gridTemplateColumns: 'auto 1fr',
        columnGap: 1.5,
        rowGap: 1,
        '@media (min-width: 410px)': {
          columnGap: 3,
        },
        m: 0,
        maxWidth: '100%',
      }}
    >
      <Term icon={<LocationOnOutlinedIcon sx={ICON_SX} />}>Osoite:</Term>
      <Detail>
        <Typography
          variant='p3'
          sx={{
            '& a': {
              display: 'flex',
              alignItems: 'center',
              minHeight: height,
              color: 'typography.light',
              textDecoration: 'none',
              wordBreak: 'break-word',
              transition: 'color 0.15s ease',
              '&:hover': {
                color: 'secondary.main',
                textDecoration: 'underline',
              },
            },
          }}
        >
          <RouterLink to='/contacts'>Kuormaajantie 6, 40320, Jyväskylä</RouterLink>
        </Typography>
      </Detail>
      <Term icon={<PhoneOutlinedIcon sx={ICON_SX} />}>
        <Box component='span' sx={{ '@media (min-width: 410px)': { display: 'none' } }}>
          Puhelin:
        </Box>
        <Box component='span' sx={{ display: 'none', '@media (min-width: 410px)': { display: 'inline' } }}>
          Puhelinnumero:
        </Box>
      </Term>
      <Detail>
        <Typography variant='p3'>
          <CustomLink href='tel:0452393591' height={height}>
            0452393591
          </CustomLink>
        </Typography>
      </Detail>
      <Term icon={<EmailOutlinedIcon sx={ICON_SX} />}>Sähköposti:</Term>
      <Detail>
        <Typography variant='p3'>
          <CustomLink href='mailto:huoltoykkoset@gmail.com' height={height}>
            huoltoykkoset@gmail.com
          </CustomLink>
        </Typography>
      </Detail>
      <Term icon={<ReceiptLongOutlinedIcon sx={ICON_SX} />}>Laskut:</Term>
      <Detail>
        <Typography variant='p3'>
          <CustomLink href='mailto:huoltoykkoset.laskutus@gmail.com' height={height}>
            huoltoykkoset.laskutus@gmail.com
          </CustomLink>
        </Typography>
      </Detail>
      <Term icon={<BadgeOutlinedIcon sx={ICON_SX} />}>Y-tunnus:</Term>
      <Detail>
        <Typography variant='p3' sx={{ display: 'flex', alignItems: 'center', height }}>
          3422467-8
        </Typography>
      </Detail>
    </Box>
  );
};

export default ContactDetails;
